import React from "react";
import { Box, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const WitnessItem = ({ witness }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id: String( witness.witness_id), });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition ?? "transform 200ms ease",
    zIndex: isDragging ? 999 : "auto",
    opacity: isDragging ? 0.7 : 1,
    position: "relative",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          py: 1.2,
          px: 1,
          borderRadius: 2,
          border: "1px solid",
          borderColor: isDragging ? "primary.main" : "divider",
          bgcolor: isDragging ? "action.selected" : "background.paper",
          mb: 1,
          boxShadow: isDragging ? 4 : 0,
          transition: "border-color 0.15s, background-color 0.15s, box-shadow 0.15s",
          "&:hover": {
            borderColor: "primary.light",
            bgcolor: "action.hover",
          },
        }}
      >
        <Box
          {...attributes}
          {...listeners}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: isDragging ? "grabbing" : "grab",
            color: isDragging ? "primary.main" : "text.disabled",
            flexShrink: 0,
            touchAction: "none",
            userSelect: "none",
            p: 0.5,
            borderRadius: 1,
            "&:hover": { color: "text.secondary", bgcolor: "action.hover" },
          }}
          aria-label="Arrastrar testigo"
        >
          <DragIndicatorIcon fontSize="small" />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {witness.medio}
          </Typography>
          {witness.url && (
            <Typography
              variant="caption"
              component="a"
              href={witness.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "primary.main",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
                textDecoration: "none",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              {witness.url}
            </Typography>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default WitnessItem;
